var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8354 22.364L22.3639 22.8354C22.1036 23.0957 21.6815 23.0957 21.4211 22.8354L16 17.4142L10.5788 22.8353C10.3185 23.0957 9.89638 23.0957 9.63603 22.8353L9.16462 22.3639C8.90427 22.1036 8.90427 21.6815 9.16462 21.4211L14.5858 16L9.16462 10.5788C8.90427 10.3185 8.90427 9.89638 9.16462 9.63603L9.63602 9.16463C9.89637 8.90428 10.3185 8.90428 10.5788 9.16463L16 14.5858L21.4211 9.16462C21.6815 8.90427 22.1036 8.90427 22.3639 9.16462L22.8354 9.63602C23.0957 9.89637 23.0957 10.3185 22.8354 10.5788L17.4142 16L22.8354 21.4211C23.0957 21.6815 23.0957 22.1036 22.8354 22.364Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.b05770c1eea000edca99402ffdedda68.svg";
export { ForwardRef as ReactComponent };